import { router } from "@inertiajs/vue3"
import { ref } from "vue"

import { duplicateItemPath } from "@/routes"

export function useDuplicateItem(itemId: string) {
  const duplicateOpen = ref(false)
  const duplicating = ref(false)

  function confirmDuplicate(data: { name: string; asset_code: string; reduce_quantity: boolean }) {
    duplicating.value = true
    router.post(
      duplicateItemPath({ id: itemId }),
      {
        name: data.name,
        asset_code: data.asset_code || undefined,
        reduce_quantity: data.reduce_quantity ? "1" : undefined,
      },
      {
        onSuccess: () => (duplicateOpen.value = false),
        onFinish: () => (duplicating.value = false),
      },
    )
  }

  return { duplicateOpen, duplicating, confirmDuplicate }
}
